interface PaginationProps {
  current: number;
  total: number;
  onChange: (page: number) => void;
}

export default function Pagination({ current, total, onChange }: PaginationProps) {
  if (total <= 1) return null;

  const pages: (number | string)[] = [];
  if (total <= 7) {
    for (let i = 1; i <= total; i += 1) pages.push(i);
  } else {
    pages.push(1);
    if (current > 3) pages.push("...");
    const start = Math.max(2, current - 1);
    const end = Math.min(total - 1, current + 1);
    for (let i = start; i <= end; i += 1) pages.push(i);
    if (current < total - 2) pages.push("...");
    pages.push(total);
  }

  return (
    <nav
      className="flex flex-wrap items-center justify-center gap-2"
      aria-label="分页导航"
    >
      <button
        type="button"
        onClick={() => onChange(Math.max(1, current - 1))}
        disabled={current === 1}
        className="flex h-9 items-center gap-1 rounded-md border border-background-300 bg-background-50 px-3 text-sm font-medium text-foreground-700 transition-colors hover:bg-background-100 disabled:cursor-not-allowed disabled:opacity-40"
      >
        <i className="ri-arrow-left-s-line" aria-hidden="true" />
        上一页
      </button>

      {pages.map((page, index) =>
        typeof page === "number" ? (
          <button
            key={page}
            type="button"
            onClick={() => onChange(page)}
            aria-current={page === current ? "page" : undefined}
            className={
              page === current
                ? "h-9 w-9 rounded-md bg-primary-500 text-sm font-bold text-background-50"
                : "h-9 w-9 rounded-md border border-background-300 bg-background-50 text-sm font-medium text-foreground-700 transition-colors hover:bg-background-100"
            }
          >
            {page}
          </button>
        ) : (
          <span
            key={`ellipsis-${index}`}
            className="flex h-9 w-6 items-center justify-center text-foreground-400"
          >
            <i className="ri-more-line" aria-hidden="true" />
          </span>
        ),
      )}

      <button
        type="button"
        onClick={() => onChange(Math.min(total, current + 1))}
        disabled={current === total}
        className="flex h-9 items-center gap-1 rounded-md border border-background-300 bg-background-50 px-3 text-sm font-medium text-foreground-700 transition-colors hover:bg-background-100 disabled:cursor-not-allowed disabled:opacity-40"
      >
        下一页
        <i className="ri-arrow-right-s-line" aria-hidden="true" />
      </button>
    </nav>
  );
}